import request from '@/utils/request'

//菜单管理分页查询
export function menuList(data) {
  return request({
    url: '/admin_auth/v1/list',
    method: 'post',
    data
  })
}

//新增菜单
export function addMenuList(data) {
  return request({
    url: '/admin_auth/v1/add',
    method: 'post',
    data
  })
}

//编辑菜单
export function updataMenuList(data) {
  return request({
    url: '/admin_auth/v1/update',
    method: 'post',
    data
  })
}

//查询单个
export function detailId(data) {
  return request({
    url: '/admin_auth/v1/detail',
    method: 'get',
    params: data
  })
}

//删除
export function deleteMenu(data) {
  return request({
    url: '/admin_auth/v1/delete',
    method: 'get',
    params: data
  })
}

//全部菜单查询不带分页
export function muList(data) {
  return request({
    url: '/admin_auth/v1/listAll',
    method: 'get',
    params: data
  })
}
